import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Button as BaseButton } from '@leroy-merlin-br/backyard-react-ui'

const bodyStyles = ({ theme }) => css`
  label: document-status__body;

  height: 100%;
  text-align: center;
  padding: ${theme.spacings.zetta} 0;
`

const buttonStyles = ({ theme }) => css`
  label: document-status__button;

  margin-top: ${theme.spacings.tera};

  ${theme.media.kilo} {
    margin: ${theme.spacings.tera} 0;
  }
`

export const Body = styled('div')(bodyStyles)
export const Button = styled(BaseButton)(buttonStyles)
